import { render, staticRenderFns } from "./Oratore.vue?vue&type=template&id=267310f2&scoped=true&"
import script from "./Oratore.vue?vue&type=script&lang=js&"
export * from "./Oratore.vue?vue&type=script&lang=js&"
import style0 from "./Oratore.vue?vue&type=style&index=0&id=267310f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267310f2",
  null
  
)

export default component.exports